import RecategorizeButtonComponent from './RecategorizeButton';
import withAskRequests from './withAskRequests';
import withQueue from './withQueue';

export const RecategorizeButton = withAskRequests(RecategorizeButtonComponent);
export const QueueReCategorizeButton = withQueue(RecategorizeButtonComponent);
